import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { useRouter } from 'next/router'

// Constants
import { SearchCategory_LowerCase } from '../../../utils/types'

// Styles
import Icon from '@/assets/icons'
import styles from './style.module.scss'

const cx = classnames.bind(styles)

const MoreButton = ({ category }: { category: SearchCategory_LowerCase }) => {
  const router = useRouter()
  const { t } = useTranslation()

  const searchParams = router.query
  const queryParams = (() => {
    const newParams = {
      ...searchParams,
      category: category,
    }
    const queryString = new URLSearchParams(newParams as Record<string, string>).toString()
    return `?${queryString}`
  })()

  return (
    <div className={cx('more-button-wrapper')}>
      <Link className={cx('more-button')} href={queryParams}>
        <span className={cx('more-button-text')}>{t('More_Button_Text')}</span>
        <div className={cx('more-button-icon')}>
          <Icon.ArrowRight_LiveMallClub />
        </div>
      </Link>
    </div>
  )
}

export default MoreButton
